import React from "react";
import Pill from "./Pill";
import { STATUS_BADGE } from "./constants";

// Status pill matching the Figma design. Colours come from STATUS_BADGE per
// status; falls back to a neutral grey pill for unknown states.
const StatusBadge = ({ status }) => {
  const config =
    STATUS_BADGE[status] || { label: status || "—", bg: "#EEEDF0", text: "#807E83", border: "#D1CFD4" };
  return (
    <Pill bg={config.bg} text={config.text} border={config.border}>
      {config.label}
    </Pill>
  );
};

export default StatusBadge;
